import * as patients from '../../../apis/patient'
import { getCases } from '../case'
import { hideModal, stopSaving } from '../core'
import { createSelector } from 'reselect'
import * as cookies from '../../../utilties/cookies'
import history from '../../../utilties/history'
import * as protocol from '../../../apis/observationalProtocol'
import { syncCookies } from '../../../utilties/utilities'

const FETCH_PATIENT_REQUESTED = 'FETCH_PATIENT_REQUESTED'
const FETCH_PATIENT_SUCCESS = 'FETCH_PATIENT_SUCCESS'
const FETCH_PATIENT_FAILED = 'FETCH_PATIENT_FAILED'

export const getPatient = () => (dispatch) => {
	dispatch({ type: FETCH_PATIENT_REQUESTED, data: {} })
	return patients.fetchPatient().then((patient) => {
		if (patient) {
			return dispatch({ type: FETCH_PATIENT_SUCCESS, data: patient })
		} else {
			return dispatch({ type: FETCH_PATIENT_FAILED, data: {} })
		}
	})
	return
}

const FETCH_OWNER_MFA_STATE_REQUESTED = 'FETCH_OWNER_MFA_STATE_REQUESTED'
const FETCH_OWNER_MFA_STATE_SUCCESS = 'FETCH_OWNER_MFA_STATE_SUCCESS'
const FETCH_OWNER_MFA_STATE_FAILED = 'FETCH_OWNER_MFA_STATE_FAILED'

export const getOwnerMFAState = (data, email) => (dispatch) => {
    dispatch({ type: FETCH_OWNER_MFA_STATE_REQUESTED, data: {} })
	return patients.fetchOwnerMFAState(data, email).then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: FETCH_OWNER_MFA_STATE_SUCCESS, data: response.data })
        } else {
            return dispatch({ type: FETCH_OWNER_MFA_STATE_FAILED, data: {} })
        }
    })
    return
}

const UPDATE_PATIENT_REQUESTED = 'UPDATE_PATIENT_REQUESTED'
const UPDATE_PATIENT_SUCCESS = 'UPDATEPATIENT_SUCCESS'
const UPDATE_PATIENT_FAILED = 'UPDATEPATIENT_FAILED'

export const updatePatient = (birthDate, firstName, lastName, phone, countryId) => (dispatch) => {
	dispatch({ type: UPDATE_PATIENT_REQUESTED, data: {} })
	var patient = {
		birthDate: birthDate,
		firstName: firstName,
		lastName: lastName,
		phoneNumber: phone,
		countryId: countryId
	}
	return patients.updatePatient(patient).then((response) => {
		syncCookies();
		if (response) {
			if (response.surveyId && response.surveyInstanceId && response.caseId && response.protocolId) {
				history.push(
					`/survey/${response.caseId}/${response.protocolId}/${response.surveyInstanceId}/${response.surveyId}`
				)
			} else {
				history.push(`/`)
			}
			return dispatch({ type: UPDATE_PATIENT_SUCCESS, data: response })
		} else {
			return dispatch({ type: UPDATE_PATIENT_FAILED, data: {} })
		}
	})
	return
}

export const updatePatientFirstTouch = ({
	birthDate,
	firstName,
	lastName,
	middleName,
	phoneNumber,
	phoneCountryCode,
	countryId,
	internalTerms,
	thirdPartyTerms,
	treatmentDate,
}) => (dispatch) => {

	dispatch({ type: UPDATE_PATIENT_REQUESTED, data: {} })

	var patient = {
		birthDate: birthDate,
		firstName: firstName,
		lastName: lastName,
		middleName: middleName,
		phoneNumber: phoneNumber,
		phoneCountryCode: phoneCountryCode,
		countryId: countryId,
		dateJoined: new Date(),
		internalTerms: internalTerms,
		thirdPartyTerms: thirdPartyTerms,
		treatmentDate: treatmentDate,
	}

	return patients.updatePatient(patient).then((response) => {
		syncCookies();
		if (response) {
			if (response.isSuccessful) {
				if (response.surveyId && response.surveyInstanceId && response.caseId && response.protocolId) {
					history.push(
						`/survey/${response.caseId}/${response.protocolId}/${response.surveyInstanceId}/${response.surveyId}`
					)
				} else {
					protocol.getSurveyNavigation(0, response.caseId, 0, response.languageId).then((nextSurvey) => {
						if (nextSurvey && nextSurvey.isSuccessful && nextSurvey.nextSurveyInstanceId) {
							history.push(`/survey/${nextSurvey.nextCaseId}/${nextSurvey.nextProtocolId}/${nextSurvey.nextSurveyInstanceId}/${nextSurvey.nextSurveyId}`)
						} else {
							history.push(`/`)
						}
					}).catch(() => {
						history.push(`/`)
					})
				}

				return dispatch({ type: UPDATE_PATIENT_SUCCESS, data: response })
			}
			else {
				switch (response.errorCode) {
					case 8:
						dispatch({
							type: 'SET_SNACKBAR_MESSAGE',
							data: {
								message: response.errorMessage.toLowerCase().includes('invalid phone number format') ? 'app.general.wrongPhoneNumber' : response.errorMessage,
								isSuccess: false
							}
						})
						break;
					case 26:
						history.push(`/auth/mfa`)
						break;
					case 27:
						history.push(`/auth/terms`)
						break;
					case 48:
						dispatch({
							type: 'SET_SNACKBAR_MESSAGE',
							data: {
								message: 'app.general.wrongPhoneNumber',
								isSuccess: false
							}
						})
				}

                return;
            }
		} else if(!response || !response.redirectTo) {
			return dispatch({ type: UPDATE_PATIENT_FAILED, data: {} })
		}
	})
}

const SET_USER_LANGUAGE_REQUESTED = 'SET_USER_LANGUAGE_REQUESTED'
const SET_USER_LANGUAGE_SUCCESS = 'SET_USER_LANGUAGE_SUCCESS'
const SET_USER_LANGUAGE_FAILED = 'SET_USER_LANGUAGE_FAILED'

export const setPatientLanguage = (patientId, language) => (dispatch) => {
	dispatch({ type: SET_USER_LANGUAGE_REQUESTED, data: {} })
	// let user = cookies.get('user')
	return patients.updatePatientLanguage(patientId, language).then((response) => {
		if (response) {
			// dispatch(getFullUserById(user.id))
			dispatch(getPatient(patientId))
		} else {
			return dispatch({ type: SET_USER_LANGUAGE_FAILED, data: {} })
		}
	})
	return
}

export const setPatientLanguageById = (patientId, language) => (dispatch) => {
	dispatch({ type: SET_USER_LANGUAGE_REQUESTED, data: {} })
	// let user = cookies.get('user')
	return patients.updatePatientLanguageById(patientId, language).then((response) => {
		if (response) {
            dispatch(hideModal())
			dispatch(getPatient(patientId))

            window.location.reload();
        } else {
			return dispatch({ type: SET_USER_LANGUAGE_FAILED, data: {} })
		}
	})
	return
}

const GET_TEAM_BACKGROUND_REQUESTED = 'GET_TEAM_BACKGROUND_REQUESTED'
const GET_TEAM_BACKGROUND_SUCCESS = 'GET_TEAM_BACKGROUND_SUCCESS'
const GET_TEAM_BACKGROUND_FAILED = 'SET_USER_LANGUAGE_FAILED'

export const getTeamBackground = () => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamBackground?.url)
		return
	
	dispatch({ type: GET_TEAM_BACKGROUND_REQUESTED, data: {} })
	return patients.fetchTeamBackground().then((data) => {
		console.warn('BACKGROUND_LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_BACKGROUND_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_BACKGROUND_FAILED, data: {} })
		}
	})
	return
}

export const getTeamBackgroundByEmail = (email) => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamBackground)
		return
	
	dispatch({ type: GET_TEAM_BACKGROUND_REQUESTED, data: {} })
	return patients.fetchTeamBackgroundByEmail(email).then((data) => {
		console.warn('BACKGROUND_LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_BACKGROUND_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_BACKGROUND_FAILED, data: {} })
		}
	})
	return
}

export const getTeamBackgroundByEncryptedLink = (encryptedData) => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamBackground)
		return
	
	dispatch({ type: GET_TEAM_BACKGROUND_REQUESTED, data: {} })
	return patients.fetchTeamBackgroundByEncryptedLink(encryptedData).then((data) => {
		console.warn('BACKGROUND_LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_BACKGROUND_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_BACKGROUND_FAILED, data: {} })
		}
	})
	return
}

const RESET_TEAM_BACKGROUND = 'RESET_TEAM_BACKGROUND'

export const resetTeamBackground = () => (dispatch) => {
	return dispatch({ type: RESET_TEAM_BACKGROUND, data: {} })
}

const GET_TEAM_LOGO_REQUESTED = 'GET_TEAM_LOGO_REQUESTED'
const GET_TEAM_LOGO_SUCCESS = 'GET_TEAM_LOGO_SUCCESS'
const GET_TEAM_LOGO_FAILED = 'GET_TEAM_LOGO_FAILED'

export const getTeamLogo = () => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamLogo?.url)
		return
	
	dispatch({ type: GET_TEAM_LOGO_REQUESTED, data: {} })
	return patients.fetchTeamLogo().then((data) => {
		console.warn('LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_LOGO_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_LOGO_FAILED, data: {} })
		}
	})
	return
}

const RESET_TEAM_LOGO = 'RESET_TEAM_LOGO'

export const resetTeamLogo = () => (dispatch) => {
	return dispatch({ type: RESET_TEAM_LOGO, data: {} })
}

const FETCH_PATIENT_UPDATES_REQUESTED = 'FETCH_PATIENT_UPDATES_REQUESTED'
const FETCH_PATIENT_UPDATES_SUCCESS = 'FETCH_PATIENT_UPDATES_SUCCESS'
const FETCH_PATIENT_UPDATES_FAILED = 'FETCH_PATIENT_UPDATES_FAILED'

export const getPatientUpdates = (lastSeenRecordId) => (dispatch, getState) => {
	dispatch({ type: FETCH_PATIENT_UPDATES_REQUESTED, data: {} })

	return patients.fetchPatientUpdates(lastSeenRecordId).then((updates) => {
        let wereAllPatientUpdatesLoaded = false;

        if (updates && updates.isSuccessful) {

			let data = updates.data.items;

            wereAllPatientUpdatesLoaded = !updates.data.canLoadMore;

			if (lastSeenRecordId) {
				data = getState().patient.patientUpdates.concat(data)
            }

			return dispatch({ type: FETCH_PATIENT_UPDATES_SUCCESS, data: { items: data, wereAllPatientUpdatesLoaded } })
		}
		else
        {
			return dispatch({ type: FETCH_PATIENT_UPDATES_FAILED, data: { items: [], wereAllPatientUpdatesLoaded } })
        }
    })
    return
}

const MARK_PATIENT_UPDATES_READ_REQUESTED = 'MARK_PATIENT_UPDATES_READ_REQUESTED'
const MARK_PATIENT_UPDATES_READ_SUCCESS = 'MARK_PATIENT_UPDATES_READ_SUCCESS'
const MARK_PATIENT_UPDATES_READ_FAILED = 'MARK_PATIENT_UPDATES_READ_FAILED'

export const markPatientUpdateAsRead = (id, ids) => (dispatch, getState) => {
    dispatch({ type: MARK_PATIENT_UPDATES_READ_REQUESTED, data: {} })

    return patients.markPatientUpdateAsRead(ids && ids.length ? ids : [id]).then((response) => {
		if (response && response.isSuccessful) {

			let items = getState().patient.patientUpdates.slice();

			items.filter(x => x.id === id).forEach(x => x.readUtc = new Date())

			dispatch(getCases())

            return dispatch({ type: MARK_PATIENT_UPDATES_READ_SUCCESS, data: items })
		} else
        {
            return dispatch({ type: MARK_PATIENT_UPDATES_READ_FAILED, data: {} })
        }
    })
}



export const getTeamLogoByEmail = (email) => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamLogo?.url)
		return
	
	dispatch({ type: GET_TEAM_LOGO_REQUESTED, data: {} })
	return patients.fetchTeamLogoByEmail(email).then((data) => {
		console.warn('LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_LOGO_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_LOGO_FAILED, data: {} })
		}
	})
	return
}

export const getTeamLogoByEncryptedLink = (encryptedData) => (dispatch, getState) => {
	let state = getState()
	if(state && state.patient && state.patient.teamLogo?.url)
		return
	
	dispatch({ type: GET_TEAM_LOGO_REQUESTED, data: {} })
	return patients.fetchTeamLogoByEncryptedLink(encryptedData).then((data) => {
		console.warn('LOGO_SUCCESS!!!', data)
		if (data && data.isSuccessful) {
			return dispatch({ type: GET_TEAM_LOGO_SUCCESS, data: data })
		} else {
			return dispatch({ type: GET_TEAM_LOGO_FAILED, data: {} })
		}
	})
	return
}


const GET_PATIENT_IS_REGISTRATION_FINISHED_REQUESTED = 'GET_PATIENT_IS_REGISTRATION_FINISHED_REQUESTED'
const GET_PATIENT_IS_REGISTRATION_FINISHED_SUCCESS = 'GET_PATIENT_IS_REGISTRATION_FINISHED_SUCCESS'
const GET_PATIENT_IS_REGISTRATION_FINISHED_FAILED = 'GET_PATIENT_IS_REGISTRATION_FINISHED_FAILED'

export const getIsRegistrationFinished = (email) => (dispatch) => {
	dispatch({ type: GET_PATIENT_IS_REGISTRATION_FINISHED_REQUESTED, data: {} })
	
	return patients.fetchIsRegistrationFinished(email).then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: GET_PATIENT_IS_REGISTRATION_FINISHED_SUCCESS, data: response.data })
        } else {
            return dispatch({ type: GET_PATIENT_IS_REGISTRATION_FINISHED_FAILED, data: {} })
        }
    })
    return
}

const GET_CREATOR_INFO_REQUESTED = 'GET_CREATOR_INFO_REQUESTED'
const GET_CREATOR_INFO_SUCCESS = 'GET_CREATOR_INFO_SUCCESS'
const GET_CREATOR_INFO_FAILED = 'GET_CREATOR_INFO_FAILED'

export const getCreatorInfoByEmail = (email, token) => (dispatch) => {
	dispatch({ type: GET_CREATOR_INFO_REQUESTED, data: {} })
	
	return patients.getCreatorInfoByEmail(email, token).then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: GET_CREATOR_INFO_SUCCESS, data: response })
        } else {
            return dispatch({ type: GET_CREATOR_INFO_FAILED, data: {} })
        }
    })
    return
}

export const getCreatorInfo = () => (dispatch) => {
	dispatch({ type: GET_CREATOR_INFO_REQUESTED, data: {} })
	
	return patients.getCreatorInfo().then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: GET_CREATOR_INFO_SUCCESS, data: response })
        } else {
            return dispatch({ type: GET_CREATOR_INFO_FAILED, data: {} })
        }
    })
    return
}

export const getCreatorInfoByEmailTemp = (email) => (dispatch) => {
	dispatch({ type: GET_CREATOR_INFO_REQUESTED, data: {} })
	
	return patients.getCreatorInfoByEmailTemp(email).then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: GET_CREATOR_INFO_SUCCESS, data: response })
        } else {
            return dispatch({ type: GET_CREATOR_INFO_FAILED, data: {} })
        }
    })
    return
}

export const getCreatorInfoByEncryptedLink = (data) => (dispatch) => {
	dispatch({ type: GET_CREATOR_INFO_REQUESTED, data: {} })
	
	return patients.getCreatorInfoByEncryptedLink(data).then((response) => {
		if (response && response.isSuccessful) {
            return dispatch({ type: GET_CREATOR_INFO_SUCCESS, data: response })
        } else {
            return dispatch({ type: GET_CREATOR_INFO_FAILED, data: {} })
        }
    })
    return
}

const DELETE_ACCOUNT_REQUESTED = 'DELETE_ACCOUNT_REQUESTED'
const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS'
const DELETE_ACCOUNT_FAILED = 'DELETE_ACCOUNT_FAILED'

export const deletePatientAccount = (patientId) => (dispatch) => {
	dispatch({ type: DELETE_ACCOUNT_REQUESTED, data: {} })
	return patients.deletePatientAccount(patientId).then((response) => {
		dispatch(stopSaving())
		dispatch(hideModal())
		if (response && response.isSuccessful) {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.accountDeletion.successMessage',
					isSuccess: true
				}
			})
		} else {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.accountDeletion.errorMessage',
					isSuccess: false
				}
			})
		}
	})
	return
}

const GET_PATIENT_REGISTRATION_LINK_REQUESTED = 'GET_PATIENT_REGISTRATION_LINK_REQUESTED'
const GET_PATIENT_REGISTRATION_LINK_SUCCESS = 'GET_PATIENT_REGISTRATION_LINK_SUCCESS'
const GET_PATIENT_REGISTRATION_LINK_FAILED = 'GET_PATIENT_REGISTRATION_LINK_FAILED'

export const getPatientRegistrationLink = () => (dispatch) => {
	dispatch({ type: GET_PATIENT_REGISTRATION_LINK_REQUESTED, data: {} })
	
	return patients.getPatientRegistrationLink().then((response) => {
		if (response && response.link) {
            return dispatch({ type: GET_PATIENT_REGISTRATION_LINK_SUCCESS, data: response.link })
        } else {
            return dispatch({ type: GET_PATIENT_REGISTRATION_LINK_FAILED, data: {} })
        }
    })
    return
}

const CHECK_IF_LINK_HAS_EXPIRED_REQUESTED = 'CHECK_IF_LINK_HAS_EXPIRED_REQUESTED'
const CHECK_IF_LINK_HAS_EXPIRED_SUCCESS = 'CHECK_IF_LINK_HAS_EXPIRED_SUCCESS'
const CHECK_IF_LINK_HAS_EXPIRED_FAILED = 'CHECK_IF_LINK_HAS_EXPIRED_FAILED'

export const checkIfSelfRegistrationLinkHasExpired = (data) => (dispatch) => {
	dispatch({ type: CHECK_IF_LINK_HAS_EXPIRED_REQUESTED, data: {} })
	return patients.checkIfSelfRegistrationLinkHasExpired(data).then((response) => {
		if (response && response.isSuccessful === true) {
			dispatch({ type: CHECK_IF_LINK_HAS_EXPIRED_SUCCESS, data: {} })
		} else {
			dispatch({ type: CHECK_IF_LINK_HAS_EXPIRED_FAILED, data: {} })
			history.push(`/auth/linkHasExpired`, true)
		}
	})
}

const SET_EMAIL_CLICK_REQUESTED = 'SET_EMAIL_CLICK_REQUESTED'
const SET_EMAIL_CLICK_SUCCESS = 'SET_EMAIL_CLICK_SUCCESS'
const SET_EMAIL_CLICK_FAILED = 'SET_EMAIL_CLICK_FAILED'

export const setEmailClickByMessageId = (messageId) => (dispatch) => {
	dispatch({ type: SET_EMAIL_CLICK_REQUESTED, data: {} })
	return patients.setEmailClickByMessageId(messageId).then((response) => {
		if (response && response.isSuccessful === true) {
			dispatch({ type: SET_EMAIL_CLICK_SUCCESS, data: {} })
		} else {
			dispatch({ type: SET_EMAIL_CLICK_FAILED, data: {} })
		}
	})
}

export const setEmailClickByPatientEmail = (email, token) => (dispatch) => {
	dispatch({ type: SET_EMAIL_CLICK_REQUESTED, data: {} })
	return patients.setEmailClickByPatientEmail(email, token).then((response) => {
		if (response && response.isSuccessful === true) {
			dispatch({ type: SET_EMAIL_CLICK_SUCCESS, data: {} })
		} else {
			dispatch({ type: SET_EMAIL_CLICK_FAILED, data: {} })
		}
	})
}

export const setEmailClickByCaseId = (caseId) => (dispatch) => {
	dispatch({ type: SET_EMAIL_CLICK_REQUESTED, data: {} })
	return patients.setEmailClickByCaseId(caseId).then((response) => {
		if (response && response.isSuccessful === true) {
			dispatch({ type: SET_EMAIL_CLICK_SUCCESS, data: {} })
		} else {
			dispatch({ type: SET_EMAIL_CLICK_FAILED, data: {} })
		}
	})
}

const initial = {
	patient: null,
	patientUpdates: [],
    wereAllPatientUpdatesLoaded: false,
    patientUpdatesAreLoading: false,
	teamBackground: null,
	teamBackgroundIsLoading: false,
	teamLogo: null,
	teamLogoIsLoading: false,
	ownerMFAState: false,
	isRegistrationFinished: null,
	creatorInfo: null,
	registrationLink: null,
	selfRegistrationLinkIsValid: false
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case UPDATE_PATIENT_SUCCESS:
		case FETCH_PATIENT_SUCCESS:
			return { ...state, patient: action.data }
		case GET_TEAM_BACKGROUND_REQUESTED:
			return { ...state, teamBackgroundIsLoading: true}
		case GET_TEAM_BACKGROUND_SUCCESS:
			return { ...state, teamBackground: action.data, teamBackgroundIsLoading: false}
		case GET_TEAM_BACKGROUND_FAILED:
			return { ...state, teamBackgroundIsLoading: false}
		case RESET_TEAM_BACKGROUND:
			return { ...state, teamBackground: null }
		case GET_TEAM_LOGO_REQUESTED:
			return { ...state, teamLogoIsLoading: true}
		case GET_TEAM_LOGO_SUCCESS:
			return { ...state, teamLogo: action.data, teamLogoIsLoading: false}
		case GET_TEAM_LOGO_FAILED:
			return { ...state, teamLogoIsLoading: false }
		case RESET_TEAM_LOGO:
			return { ...state, teamLogo: null }
		case FETCH_PATIENT_UPDATES_REQUESTED:
			return { ...state, patientUpdatesAreLoading: true }
        case FETCH_PATIENT_UPDATES_SUCCESS:
        case FETCH_PATIENT_UPDATES_FAILED:
			return { ...state, patientUpdates: action.data.items, patientUpdatesAreLoading: false, wereAllPatientUpdatesLoaded: action.data.wereAllPatientUpdatesLoaded }
		case MARK_PATIENT_UPDATES_READ_SUCCESS:
			return { ...state, patientUpdates: action.data }
		case FETCH_OWNER_MFA_STATE_SUCCESS:
            return { ...state, ownerMFAState: action.data }
		case GET_PATIENT_IS_REGISTRATION_FINISHED_REQUESTED:
			return { ...state, isRegistrationFinished: null}
		case GET_PATIENT_IS_REGISTRATION_FINISHED_SUCCESS:
			return { ...state, isRegistrationFinished: action.data}
		case GET_CREATOR_INFO_REQUESTED:
			return { ...state, creatorInfo: null}
		case GET_CREATOR_INFO_SUCCESS:
			return { ...state, creatorInfo: action.data}
		case GET_PATIENT_REGISTRATION_LINK_SUCCESS:
			return { ...state, registrationLink: action.data}
		case CHECK_IF_LINK_HAS_EXPIRED_REQUESTED:
			return { ...state, selfRegistrationLinkIsValid: false }
		case CHECK_IF_LINK_HAS_EXPIRED_SUCCESS:
			return { ...state, selfRegistrationLinkIsValid: true }
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state && state.patient

export const patientSelector = createSelector(mainSelector, (patient) => { return patient.patient ? { ...patient.patient, birthDate: patient.patient.birthDate ? patient.patient.birthDate.split('T')[0].replace(/-/g, '/') : null } : {} })

export const teamBackgroundSelector = createSelector(mainSelector, (state) => {
	return state && state.teamBackground && state.teamBackground.url
})

export const teamBackgroundIsLoadingSelector = createSelector(mainSelector, (state) => {
	return state && state.teamBackgroundIsLoading
})

export const teamLogoSelector = createSelector(mainSelector, (state) => {
	return state && state.teamLogo && state.teamLogo.url
})

export const teamLogoIsLoadingSelector = createSelector(mainSelector, (state) => {
	return state && state.teamLogoIsLoading
})

export const patientUpdatesSelector = createSelector(mainSelector, (state) => {
    return state && state.patientUpdates
})

export const wereAllPatientUpdatesLoadedSelector = createSelector(mainSelector, (state) => {
	return state && state.wereAllPatientUpdatesLoaded
})

export const patientUpdatesAreLoadingSelector = createSelector(mainSelector, (state) => {
	return state && state.patientUpdatesAreLoading
})

export const ownerMFAStateSelector = createSelector(mainSelector, (state) => {
	return state && state.ownerMFAState
})

export const isRegistrationFinishedSelector = createSelector(mainSelector, (state) => {
	return state && state.isRegistrationFinished
})

export const creatorInfoSelector = createSelector(mainSelector, (state) => {
	return state && state.creatorInfo
})

export const registrationLinkSelector = createSelector(mainSelector, (state) => {
	return state && state.registrationLink
})

export const selfRegistrationLinkIsValidSelector = createSelector(mainSelector, (state) => {
	return state && state.selfRegistrationLinkIsValid
})